import { memo } from 'react'

import { SVGProps } from './types/iconType'

export const EditIcon = memo(({ style, className }: SVGProps) => {
  return (
    <svg style={style} className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <path
        d="M16 4.192a.8.8 0 0 0-.232-.568L12.376.232A.8.8 0 0 0 11.808 0a.8.8 0 0 0-.568.232L8.976 2.496.232 11.239a.8.8 0 0 0-.232.568V15.2a.8.8 0 0 0 .8.8h3.392a.8.8 0 0 0 .608-.232l8.696-8.744L15.768 4.8a.952.952 0 0 0 .176-.264.8.8 0 0 0 0-.192.56.56 0 0 0 0-.112l.056-.04zM3.864 14.399H1.6v-2.264l7.944-7.943 2.264 2.264-7.944 7.943zm9.072-9.071-2.264-2.264 1.136-1.128 2.256 2.256-1.128 1.136z"
        fillRule="evenodd"
      />
    </svg>
  )
})
